export type AvailabilityStatus = 'READY' | 'BUSY' | 'AWAY'

export type AvailabilityView = {
  teamId: number
  teamCode: string
  teamName: string
  status: AvailabilityStatus
  sinceAt: string | null
}

export const STATUS_LABELS: Record<AvailabilityStatus, string> = {
  READY: 'Gotowy',
  BUSY: 'Zajęty',
  AWAY: 'Niedostępny',
}
